import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

const RegistarPedido = (props) => {
  const formSchema = Yup.object().shape({
    assunto: Yup.string()
      .required('O assunto é obrigatório.'),
    descritivo: Yup.string()
      .required('O descritivo é obrigatório.'),
  })
  const formOptions = { resolver: yupResolver(formSchema) }

  const { register, handleSubmit, formState: { errors } } = useForm(formOptions);

  return (
  <div className="col-md-12 bg-white rounded-4 p-3">
    {props.message.length !== 0 && (
        <div className="alert alert-success alert-layer border-0 d-flex align-items-center mb-5" role="alert">
          <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-2">
            <g stroke="none" strokeWidth="1" fill="#FFFFFF" fillRule="evenodd">
              <path d="M7.48581818,10.5709091 C7.344,10.7127273 7.15781818,10.784 6.97163636,10.784 C6.78545455,10.784 6.59927273,10.7127273 6.45745455,10.5709091 L4.40072727,8.51418182 L5.42909091,7.48581818 L6.97163636,9.02836364 L10.5709091,5.42909091 L11.5992727,6.45745455 L7.48581818,10.5709091 Z M8,0 C3.58909091,0 0,3.58836364 0,8 C0,12.4109091 3.58909091,16 8,16 C12.4109091,16 16,12.4109091 16,8 C16,3.58836364 12.4109091,0 8,0 L8,0 Z" />
            </g>
          </svg>
          <div>
          {props.message}
          </div>
        </div>
        )}
    <form onSubmit={handleSubmit(props.onSubmitHandler)}>
      <div className="form-group mt-4">
        <label>Assunto</label>
        <select {...register("assunto")} defaultValue="" className={`form-control ${errors.assunto ? 'is-invalid' : ''}`}>
          <option value="" disabled>Selecione uma opção</option>
          <option value="Alteração de dados pessoais">Alteração de dados pessoais</option>
          <option value="Acesso a benefícios">Acesso a benefícios</option>
          <option value="Esclarecimento da área privada">Esclarecimento da área privada</option>
          <option value="Outros assuntos">Outros assuntos</option>
        </select>
        <div className="invalid-feedback">{errors.assunto?.message}</div>
      </div>
      <div className="form-group mt-4">
        <label>Descritivo</label>
        <textarea {...register("descritivo")} className={`form-control ${errors.descritivo ? 'is-invalid' : ''}`} />
        <div className="invalid-feedback">{errors.descritivo?.message}</div>
      </div>
      <div className="mt-5">
        <button type="submit" className="btn btn-primary">
          Enviar pedido
        </button>
      </div>
    </form>
  </div>
  );
};

export default RegistarPedido;
